import { render } from "./abbColDirection.vue?vue&type=template&id=c06ba6f8&scoped=true"
import script from "./abbColDirection.vue?vue&type=script&lang=js"
export * from "./abbColDirection.vue?vue&type=script&lang=js"

import "./abbColDirection.vue?vue&type=style&index=0&id=c06ba6f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06ba6f8"]])

export default __exports__